import { recordPath, recordRoute } from '@/shared/registry'

/** Where the webhook pages live. */
export const webhooksPath = '/channels/webhooks'
export const createWebhookPath = `${webhooksPath}/new`
export const webhookRoute = recordRoute('channels', 'webhooks')
export const editWebhookRoute = `${webhookRoute}/edit`

/** The query parameter that presets the organization on Create Webhook, as the organization form's "Add webhook" does. */
export const organizationParameter = 'organization'

/** A webhook's details page. */
export function webhookPath(id: string): string {
  return recordPath('channels', 'webhooks', id)
}

/** Create Webhook for an organization. */
export function createWebhookFor(organizationId: string): string {
  return `${createWebhookPath}?${new URLSearchParams({ [organizationParameter]: organizationId }).toString()}`
}

/** The base of Webhook Details' slots (`detailsSlots`). */
export const webhookDetailsSlot = 'channels.webhook-details'

/** The permissions the webhook pages need. */
export const readWebhooksPermission = 'channels.webhooks.read'
export const writeWebhooksPermission = 'channels.webhooks.write'
export const deleteWebhooksPermission = 'channels.webhooks.delete'

/** The API's webhook endpoints. */
export const webhooksApi = '/channels/v1/webhooks'
export const webhookEventTypesApi = '/channels/v1/webhook-event-types'

export function webhookApi(id: string): string {
  return `${webhooksApi}/${encodeURIComponent(id)}`
}

/** An organization's webhooks, a page at a time, disabled ones too. */
export function organizationWebhooksApi(organizationId: string): string {
  return `${webhooksApi}?${new URLSearchParams({ organizationId, includeInactive: 'true' }).toString()}`
}

/** A webhook's deliveries, newest first, a page at a time, keeping only `statuses` when any are given. */
export function webhookDeliveriesApi(id: string, statuses: readonly string[] = []): string {
  const base = `${webhookApi(id)}/deliveries`
  return statuses.length === 0 ? base : `${base}?${new URLSearchParams({ filter: `status:in:${statuses.join('|')}` }).toString()}`
}

/** Resends one of a webhook's deliveries. */
export function resendDeliveryApi(id: string, deliveryId: string): string {
  return `${webhookApi(id)}/deliveries/${encodeURIComponent(deliveryId)}/resend`
}

/** Site Management's organization, for its name when Create Webhook is opened for one. */
export function organizationApi(organizationId: string): string {
  return `/site-management/v1/organizations/${encodeURIComponent(organizationId)}`
}
